import { Product } from '../components/placiFy/types';

export interface ApiProduct {
    code: string;
    name: string;
    designer: string;
    description: string;
    category: string;
    subcategory: string;
    selected_finish: string;
    price: number | string;
    specifications: string;
    brand_collection: string;
    image: string;
    Length?: string;
    Width?: string;
    Height?: string;
    Extension?: string;
    Wattage?: string;
    Weight?: string;
    Overall_Height?: string;
    Base?: string;
    Diameter?: string;
    score: number;
}

// Convert API product to Product type
export const mapApiProductToProduct = (apiProduct: ApiProduct): Product => {
    return {
        id: apiProduct.code,
        name: apiProduct.name,
        description: apiProduct.description,
        price: typeof apiProduct.price === 'string' ? parseFloat(apiProduct.price) : apiProduct.price,
        category: `${apiProduct.category} - ${apiProduct.subcategory}`,
        imageUrl: apiProduct.image,
        isEnhanced: false,
        designer: apiProduct.designer,
        brand_collection: apiProduct.brand_collection,
        // Store original API product data for product page chat
        apiProductData: {
            code: apiProduct.code,
            name: apiProduct.name,
            designer: apiProduct.designer,
            description: apiProduct.description,
            category: apiProduct.category,
            subcategory: apiProduct.subcategory,
            selected_finish: apiProduct.selected_finish,
            price: typeof apiProduct.price === 'string' ? apiProduct.price : apiProduct.price.toString(),
            specifications: apiProduct.specifications,
            brand_collection: apiProduct.brand_collection,
            image: apiProduct.image,
            Length: (apiProduct as any).Length || '',
            Width: (apiProduct as any).Width || '',
            Height: (apiProduct as any).Height || '',
            Extension: (apiProduct as any).Extension || '',
            Wattage: (apiProduct as any).Wattage || '',
            Weight: (apiProduct as any).Weight || '',
            Overall_Height: (apiProduct as any).Overall_Height || '',
            Base: (apiProduct as any).Base || '',
            Diameter: (apiProduct as any).Diameter || '',
            score: apiProduct.score || 0,
        },
    };
};

